export const memberPortalUrl = "https://memberportal.phactmi.org";
